class ProfessionalSidebar {
  constructor() {
    this.sidebar = null;
    this.overlay = null;
    this.strings = window.professionalSidebarStrings || {};
    this.init();
  }

  init() {
    if (document.body.classList.contains("template-product")) {
      this.createSidebar();
      this.bindEvents();
    }
  }

  createSidebar() {
    const strings = this.strings;
    this.overlay = document.createElement("div");
    this.overlay.className = "professional-sidebar-overlay";

    this.sidebar = document.createElement("div");
    this.sidebar.className = "professional-sidebar";
    this.sidebar.innerHTML = `
      <div class="professional-sidebar__header">
        <h3>${strings.title}</h3>
        <button class="professional-sidebar__close" aria-label="${strings.close_aria}">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="professional-sidebar__content">
        <div class="professional-sidebar__section">
          <p>${strings.description}</p>
        </div>
        <div class="professional-sidebar__section" id="professional-sidebar-form-container">
          <!-- Le formulaire Liquid sera copié ici -->
        </div>
      </div>
    `;

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.sidebar);

    // Copier le formulaire Liquid rendu dans la sidebar
    // Utiliser requestAnimationFrame pour s'assurer que le DOM est prêt
    requestAnimationFrame(() => {
      this.loadFormTemplate();
      this.fillProductName();
    });
  }

  loadFormTemplate() {
    const formContainer = this.sidebar.querySelector("#professional-sidebar-form-container");
    if (!formContainer) {
      console.error("Professional sidebar form container not found");
      return;
    }

    // Essayer de trouver le template (peut prendre un peu de temps à charger)
    const tryLoadTemplate = () => {
      const formTemplate = document.getElementById("professional-sidebar-form-template");
      if (formTemplate) {
        const formWrapper = formTemplate.querySelector(".professional-sidebar__form-wrapper");
        if (formWrapper) {
          formContainer.innerHTML = formWrapper.innerHTML;
          // Réattacher les événements après avoir chargé le formulaire
          this.bindFormEvents();
          return true;
        }
      }
      return false;
    };

    // Essayer immédiatement
    if (tryLoadTemplate()) {
      return;
    }

    // Si pas trouvé, attendre un peu et réessayer
    setTimeout(() => {
      if (!tryLoadTemplate()) {
        // Fallback: créer un formulaire basique si le template n'est pas trouvé
        console.warn("Professional sidebar form template not found, using fallback form");
        formContainer.innerHTML = this.createFallbackForm();
        this.bindFormEvents();
      }
    }, 100);
  }

  createFallbackForm() {
    const strings = this.strings;
    return `
      <form class="professional-sidebar__form" action="/contact" method="post">
        <input type="hidden" name="form_type" value="contact">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="contact[tags]" value="demande-professionnelle">
        <label for="product_info">${strings.product_info_label}</label>
        <input type="text" name="contact[product_info]" value="" disabled class="professional-sidebar__input">
        <input type="text" name="contact[prenom]" placeholder="${strings.first_name_placeholder}" required class="professional-sidebar__input" autocomplete="given-name">
        <input type="text" name="contact[nom]" placeholder="${strings.last_name_placeholder}" required class="professional-sidebar__input" autocomplete="family-name">
        <input type="text" name="contact[entreprise]" placeholder="${strings.company_placeholder}" class="professional-sidebar__input" autocomplete="organization">
        <input type="email" name="contact[email]" placeholder="${strings.email_placeholder}" required class="professional-sidebar__input" autocomplete="email">
        <input type="tel" name="contact[telephone]" placeholder="${strings.phone_placeholder}" class="professional-sidebar__input" autocomplete="tel">
        <input type="text" name="contact[pays]" placeholder="${strings.country_placeholder}" required class="professional-sidebar__input" autocomplete="country">
        <label for="statut">${strings.status_label}</label>
        <select name="contact[statut]" id="statut" required class="professional-sidebar__input professional-sidebar__select">
          <option value="">${strings.status_placeholder}</option>
          <option value="gallery">${strings.status_option_gallery}</option>
          <option value="architect">${strings.status_option_architect}</option>
          <option value="other">${strings.status_option_other}</option>
        </select>
        <input type="text" name="contact[statut_autre]" placeholder="${strings.status_other_placeholder}" style="display: none; margin-top: 10px;" class="professional-sidebar__input" id="statut_autre">
        <textarea name="contact[body]" placeholder="${strings.message_placeholder}" required class="professional-sidebar__input professional-sidebar__textarea" rows="5"></textarea>
        <div class="newsletter-optin">
          <label class="checkbox-label">
            <input type="checkbox" name="newsletter_optin" value="1">
            <span class="checkbox-custom"></span>
            ${strings.newsletter_label}
          </label>
          <p class="newsletter-info">${strings.newsletter_description}</p>
        </div>
        <button type="submit" class="professional-sidebar__submit">${strings.submit_label}</button>
      </form>
    `;
  }

  bindEvents() {
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (!target || !(target instanceof Element)) return;

      // Vérifier si l'élément cliqué ou un parent a la classe professional-sidebar-trigger
      const trigger = target.closest(".professional-sidebar-trigger");
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.open();
        return;
      }

      // Fallback: vérifier le texte pour les boutons/liens sans classe
      const buttonOrLink = target.closest("button, a");
      if (buttonOrLink) {
        const triggerText = (buttonOrLink.textContent || "").trim().toLowerCase();
        const textMatches =
          triggerText.includes("profession") || triggerText.includes("request") || triggerText.includes("demande");

        if (textMatches) {
          e.preventDefault();
          e.stopPropagation();
          this.open();
        }
      }
    });

    if (this.sidebar) {
      const closeButton = this.sidebar.querySelector(".professional-sidebar__close");
      if (closeButton) {
        closeButton.addEventListener("click", () => this.close());
      }
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen()) {
        this.close();
      }
    });
  }

  bindFormEvents() {
    if (this.sidebar) {
      const form = this.sidebar.querySelector(".professional-sidebar__form");
      if (form) {
        // Éviter d'attacher les événements plusieurs fois
        if (form.dataset.eventsBound === "true") {
          return;
        }
        form.dataset.eventsBound = "true";

        // Le formulaire Shopify natif gère automatiquement le CAPTCHA
        // On intercepte juste pour formater le message et gérer l'abonnement Brevo
        form.addEventListener("submit", (e) => {
          this.handleFormSubmit(e);
        });

        const statutSelect = form.querySelector('select[name="contact[statut]"]');
        const statutAutreInput = form.querySelector('input[name="contact[statut_autre]"]');

        if (statutSelect && statutAutreInput) {
          statutSelect.addEventListener("change", () => {
            if (statutSelect.value === "other") {
              statutAutreInput.style.display = "block";
              statutAutreInput.required = true;
            } else {
              statutAutreInput.style.display = "none";
              statutAutreInput.required = false;
              statutAutreInput.value = "";
            }
          });
        }
      }
    }
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton ? submitButton.textContent : "";
    const strings = this.strings;

    try {
      // Afficher le chargement
      if (submitButton) {
        submitButton.textContent = strings.loading;
        submitButton.disabled = true;
      }
      this.clearMessages();

      // Formater le message avec toutes les informations
      const formData = new FormData(form);
      const statusValue = formData.get("contact[statut]");
      const statusLabel = this.getStatusLabel(statusValue, formData.get("contact[statut_autre]"));
      const originalBody = formData.get("contact[body]") || "";

      const messageBody = `
${strings.body_heading}

${strings.personal_info_heading}
- ${strings.first_name_label}: ${formData.get("contact[prenom]")}
- ${strings.last_name_label}: ${formData.get("contact[nom]")}
- ${strings.email_label}: ${formData.get("contact[email]")}
- ${strings.phone_label}: ${formData.get("contact[telephone]") || strings.phone_missing}

${strings.professional_info_heading}
- ${strings.company_label}: ${formData.get("contact[entreprise]")}
- ${strings.country_label}: ${formData.get("contact[pays]")}
- ${strings.status_field_label}: ${statusLabel}

${strings.message_label}
${originalBody}
      `.trim();

      formData.set("contact[body]", messageBody);

      // Récupérer le token CAPTCHA du formulaire Shopify
      const captchaToken =
        form.querySelector('input[name="g-recaptcha-response"]')?.value ||
        form.querySelector('[name*="captcha"]')?.value;

      // Soumettre via AJAX
      const response = await fetch("/contact", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (response.ok) {
        // Succès
        this.showSuccessMessage();
        form.reset();
        this.fillProductName();

        // Gérer l'abonnement Brevo
        const newsletterOptin = form.querySelector('input[name="newsletter_optin"]');
        if (newsletterOptin && newsletterOptin.checked) {
          await this.subscribeToNewsletter({
            email: formData.get("contact[email]"),
            firstName: formData.get("contact[prenom]"),
            lastName: formData.get("contact[nom]"),
          });
        }
      } else {
        // Erreur
        const errorText = await response.text();
        if (errorText.includes("captcha") || errorText.includes("CAPTCHA")) {
          // Si erreur CAPTCHA, laisser le formulaire se soumettre normalement
          form.submit();
        } else {
          this.showErrorMessage();
        }
      }
    } catch (error) {
      console.error("Form submission error:", error);
      this.showErrorMessage();
    } finally {
      if (submitButton) {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      }
    }
  }

  showSuccessMessage() {
    const strings = this.strings;
    const form = this.sidebar.querySelector(".professional-sidebar__form");
    this.clearMessages();

    const successDiv = document.createElement("div");
    successDiv.className = "professional-sidebar__message professional-sidebar__message--success";
    successDiv.innerHTML = `
      <div class="success-icon">✓</div>
      <div class="message-content">
        <h4>${strings.success_title}</h4>
        <p>${strings.success_message}</p>
        <p>${strings.success_followup}</p>
      </div>
    `;

    form.parentNode.insertBefore(successDiv, form.nextSibling);
  }

  showErrorMessage() {
    const strings = this.strings;
    const form = this.sidebar.querySelector(".professional-sidebar__form");
    this.clearMessages();

    const errorDiv = document.createElement("div");
    errorDiv.className = "professional-sidebar__message professional-sidebar__message--error";
    errorDiv.innerHTML = `
      <div class="error-icon">❌</div>
      <div class="message-content">
        <h4>${strings.error_title}</h4>
        <p>${strings.error_message}</p>
      </div>
    `;

    form.parentNode.insertBefore(errorDiv, form.nextSibling);

    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 8000);
  }

  showCaptchaMessage(formData) {
    const strings = this.strings;
    const form = this.sidebar.querySelector(".professional-sidebar__form");
    this.clearMessages();

    const captchaDiv = document.createElement("div");
    captchaDiv.className = "professional-sidebar__message professional-sidebar__message--warning";

    const params = new URLSearchParams();
    const productInfo = formData?.get("contact[product_info]");
    if (productInfo) params.set("product_info", productInfo);
    params.set("type", "professional");
    const contactUrl = `/pages/contact?${params.toString()}`;

    captchaDiv.innerHTML = `
      <div class="warning-icon">⚠️</div>
      <div class="message-content">
        <h4>${strings.captcha_title}</h4>
        <p>${strings.captcha_line1}</p>
        <p>${strings.captcha_line2}</p>
        <a class="button button--primary" href="${contactUrl}">
          ${strings.captcha_button}
        </a>
      </div>
    `;

    form.parentNode.insertBefore(captchaDiv, form.nextSibling);
  }

  clearMessages() {
    const messages = this.sidebar.querySelectorAll(".professional-sidebar__message");
    messages.forEach((message) => message.remove());
  }

  async subscribeToNewsletter(contactData) {
    try {
      if (!window.brevoApiKey) {
        console.warn("Brevo API key not found");
        return;
      }

      const brevoPayload = {
        email: contactData.email,
        attributes: {
          FIRSTNAME: contactData.firstName || "",
          LASTNAME: contactData.lastName || "",
        },
        updateEnabled: true,
      };

      const response = await fetch("https://api.brevo.com/v3/contacts", {
        method: "POST",
        headers: {
          "api-key": window.brevoApiKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(brevoPayload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.warn("Brevo subscription failed:", response.status, errorData);
      } else {
        console.log("Successfully subscribed to Brevo newsletter");
      }
    } catch (error) {
      console.warn("Newsletter subscription error:", error);
    }
  }

  getStatusLabel(value, otherValue) {
    const strings = this.strings;
    if (value === "gallery") return strings.status_option_gallery;
    if (value === "architect") return strings.status_option_architect;
    if (value === "other") {
      return otherValue ? `${strings.status_option_other}: ${otherValue}` : strings.status_option_other;
    }
    return value || strings.status_option_other;
  }

  open() {
    if (this.sidebar && this.overlay) {
      this.fillProductName();
      this.overlay.classList.add("active");
      this.sidebar.classList.add("active");
      document.body.classList.add("sidebar-open");
    }
  }

  fillProductName() {
    if (document.body.classList.contains("template-product")) {
      const productInfoInput = this.sidebar?.querySelector('input[name="contact[product_info]"]');
      let productTitle = "";
      const titleEl = document.querySelector(".product-details h1") || document.querySelector("h1");
      if (titleEl) {
        productTitle = titleEl.textContent?.trim() || "";
      }
      const info = `${this.strings.product_info_prefix} ${productTitle}`.trim();
      if (productInfoInput && productInfoInput instanceof HTMLInputElement) {
        productInfoInput.value = info;
      }
    }
  }

  close() {
    if (this.sidebar && this.overlay) {
      this.overlay.classList.remove("active");
      this.sidebar.classList.remove("active");
      document.body.classList.remove("sidebar-open");
    }
  }

  isOpen() {
    return this.sidebar && this.sidebar.classList.contains("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.ProfessionalSidebar = new ProfessionalSidebar();
});
